import { ApolloError, gql, useQuery } from '@apollo/client';

export const query = gql`
  query DashboardStats($congressId: ID!) {
    dashboardStats(congressId: $congressId) {
      typeName
      color
      total
      registered
      registeredVoters
      registeredLate
    }
  }
`;

export interface DashboardStat {
  typeName: string;
  color: string;
  total: number;
  registered: number;
  registeredVoters: number;
  registeredLate: number;
}

interface Query {
  dashboardStats: DashboardStat[];
}

interface Vars {
  congressId: string;
}

interface UseDashboardStats {
  loading: boolean;
  error?: ApolloError;
  dashboardStats?: DashboardStat[];
  refresh: () => Promise<void>;
}

export function useDashboardStats(
  congressId: string,
  pollInterval?: number
): UseDashboardStats {
  const { data, loading, error, refetch } = useQuery<Query, Vars>(query, {
    variables: { congressId },
    fetchPolicy: 'network-only', // we always want the latest data
    pollInterval,
  });
  return {
    dashboardStats: data?.dashboardStats,
    loading,
    error,
    refresh: async () => {
      await refetch();
    },
  };
}
